import { useQuery } from "@tanstack/react-query";

import { supplementalQuestionsQueryOptionsFactory } from "~/providers/factories/supplementalQuestionsQueryOptionsFactory";

export const useListSupplementalForms = (organizationId: string) => {
  return useQuery(
    supplementalQuestionsQueryOptionsFactory.list({ organizationId }),
  );
};
